import React, { useState, Component } from 'react';
import { Badge, Button, Typography } from '@duxton-web/ui';
import { FilterOutlined } from '@duxton-web/icons';
import {
  colorOutlineDefault,
  colorContentSubtle,
} from '@duxton-web/design-tokens/themes/light';

type Props = {
  moreFiltersInitialValue: Array,
  moreFiltersCallback: Function,
  filterModal: Component, // the modal to open up when user clicks the button
  width: string,
  height: string,
};

const MoreFiltersButton = (props: Props) => {
  const getFilterCountInitialValue = () => {
    if (props.moreFiltersInitialValue) {
      return props.moreFiltersInitialValue.filter(moreFilter => moreFilter.lhs !== 'channelGroup').length;
    }
    return 0;
  };
  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const [filterCount, setFilterCount] = useState(getFilterCountInitialValue());
  const closeMoreFilters = () => {
    setShowMoreFilters(false);
  };
  const updateFilterCount = (count: number) => {
    setFilterCount(count);
  };
  const openMoreFilters = () => {
    setShowMoreFilters(true);
  };
  const onAction = (filterConditions: Array, action: 'reset' | 'apply') => {
    if (filterConditions) {
      setFilterCount(filterConditions.filter(moreFilter => moreFilter.lhs !== 'channelGroup').length);
    }
    if (action === 'apply') {
      closeMoreFilters();
    }
    props.moreFiltersCallback(filterConditions);
  };

  const FilterModal = props.filterModal;

  return (
    <div>
      <Button
        icon={<FilterOutlined style={{ fontSize: 16 }} />}
        style={{
          fontWeight: '400',
          width: props.width,
          height: props.height,
          borderColor: colorOutlineDefault,
          color: colorContentSubtle,
        }}
        onClick={openMoreFilters}
      >
        <Typography.Body level={3} style={{ marginInlineStart: 0 }}>
          More Filters
        </Typography.Body>
        {filterCount > 0 && (
          <Badge count={filterCount} color="green" type="nested" />
        )}
      </Button>

      <FilterModal
        open={showMoreFilters}
        moreFiltersInitialValue={props.moreFiltersInitialValue}
        updateFilterCount={updateFilterCount}
        onAction={onAction}
        closeFilter={closeMoreFilters}
      />

    </div>
  );
};

export default MoreFiltersButton;
